/** Pure helpers the Breakdown and Runs lists share. */

import { STATUS_STYLE, formatSeconds } from './usageUi';

interface SortView {
  sort: string;
  order: 'asc' | 'desc';
}

/**
 * Clicking the sorted column flips its order; another column starts in the
 * order `ascendingFirst` picks for it. Either way the list goes back to page 1.
 */
export function sortPatch(view: SortView, key: string, ascendingFirst: (key: string) => boolean) {
  if (view.sort === key) return { order: view.order === 'asc' ? ('desc' as const) : ('asc' as const), page: 1 };
  return { sort: key, order: ascendingFirst(key) ? ('asc' as const) : ('desc' as const), page: 1 };
}

/** A duration in milliseconds as seconds, or "Not recorded". */
export function formatDuration(ms: number | null | undefined): string {
  return ms != null ? formatSeconds(ms / 1000) : 'Not recorded';
}

/** A run status's badge; a status the page does not know reads as itself, muted. */
export function statusStyle(status: string): { className: string; label: string } {
  return new Map(Object.entries(STATUS_STYLE)).get(status) ?? { className: 'badge-neutral', label: status };
}
